import React from 'react';
import { useNavigate } from 'react-router-dom';
import { assets } from '../../../../../utils/assetsSrc';
import './goBackHeader.scss';

const GoBackHeader = ({label="",style}) => {
    const nav=useNavigate()
  return (
    <div style={style} className="heading">
      <img
        onClick={() => {
          nav(-1);
        }}
        src={assets.backArrow}
      />
      {label}
    </div>
  );
};

export default GoBackHeader;
